import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  readSubscribersListScroll,
  rememberSubscribersListScroll,
} from '../../lib/subscribersListStore';

/** Scroll the window to the top when the route pathname changes. */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if (pathname === '/subscribers') {
      window.scrollTo(0, readSubscribersListScroll());
    } else {
      window.scrollTo(0, 0);
    }
    return () => {
      if (pathname === '/subscribers') rememberSubscribersListScroll(window.scrollY);
    };
  }, [pathname]);

  return null;
}
